<template>
  <div class="pages-aboutUS">
    <div class="the-banner"></div>
    <div class="bgbox-white">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="module1-conts">
          <div class="module-title">
            <span class="title-cn">芦淞区姚家坝中医骨伤医院</span>
          </div>
          <p>芦淞区姚家坝中医骨伤医院扎根株洲市芦淞区，历经数十年的发展，从一家传统正骨诊所逐步成长为以中医骨伤为特色的现代化专科医院。医院始终秉承“传承中医正骨精髓，融合现代医疗技术”的宗旨，为周边地区乃至全省患者提供优质的骨伤诊疗服务。</p>
        </div>
      </el-col>
    </div>

    <div class="bgbox-white">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="module3-conts">
          <div class="module-title">
            <span class="title-cn">发展历程</span>
          </div>
          <el-col :xs="{span:12}" :sm="{span:8}" :md="{span:4}" :lg="{span:4}">
            <div class="step-item">
              <div class="top">
                <div class="conts">
                  <h5>起源与初创</h5>
                  <p>医院前身—“姚家坝中医正骨诊所”由当地著名骨伤科中医张氏正骨传人张济民老先生创立。诊所依托家传正骨手法和秘制中药方剂，以治疗骨折、跌打损伤闻名乡里，深受百姓信赖。</p>
                </div>
                <h6>1980年代</h6>
              </div>
            </div>
          </el-col>
          <el-col :xs="{span:12}" :sm="{span:8}" :md="{span:4}" :lg="{span:4}">
            <div class="step-item">
              <div class="down">
                <div class="conts">
                  <h5>奠定专科基础</h5>
                  <p>诊所正式注册为“姚家坝中医骨伤科医院”，成为芦淞区首批具有正规资质的民营中医骨伤专科机构。引进首批X光机，实现“手法诊断+影像辅助”的精准治疗，大幅提升骨折复位准确性。</p>
                </div>
                <h6>1990年代</h6>
              </div>
            </div>
          </el-col>
          <el-col :xs="{span:12}" :sm="{span:8}" :md="{span:4}" :lg="{span:4}">
            <div class="step-item">
              <div class="top">
                <div class="conts">
                  <h5>快速发展与品牌塑造</h5>
                  <p>被评为“株洲市中医特色专科建设单位”，张济民之子张维国接任院长，系统整理家传正骨技术并申报非物质文化遗产。参与汶川地震伤员救治工作，中医正骨疗法在应急创伤救治中发挥重要作用，获省级卫生部门表彰。</p>
                </div>
                <h6>2000年代</h6>
              </div>
            </div>
          </el-col>
          <el-col :xs="{span:12}" :sm="{span:8}" :md="{span:4}" :lg="{span:4}">
            <div class="step-item">
              <div class="down">
                <div class="conts">
                  <h5>现代化升级影响力提升</h5>
                  <p>医院通过二级中医专科医院评审，更名为“芦淞区姚家坝中医骨伤医院”，并引入CT、DR等现代设备，实现中西医结合精准诊疗。承办“湖南省中医骨伤学术交流会”，推广“张氏正骨手法”，医院特色疗法获省级科研立项。</p>
                </div>
                <h6>2010年代</h6>
              </div>
            </div>
          </el-col>
          <el-col :xs="{span:12}" :sm="{span:8}" :md="{span:4}" :lg="{span:4}">
            <div class="step-item">
              <div class="top">
                <div class="conts">
                  <h5>创新引领与社区服务深化</h5>
                  <p>获评“湖南省中医骨伤重点专科”，医院入选“株洲市中医药传承创新示范单位”，规划建设中医骨伤研究院，推动传统技艺的科研转化。</p>
                </div>
                <h6>2020</h6>
              </div>
            </div>
          </el-col>
          <el-col :xs="{span:12}" :sm="{span:8}" :md="{span:4}" :lg="{span:4}">
            <div class="step-item">
              <div class="down">
                <div class="conts">
                  <h5>扎根芦淞，守护骨健康</h5>
                  <p>更名为"株洲市芦淞区中医骨伤专科医院"，是芦淞区唯一一家公立性基层二级医疗机构</p>
                </div>
                <h6>2024</h6>
              </div>
            </div>
          </el-col>
          <el-col :xs="{span:12}" :sm="{span:8}" :md="{span:4}" :lg="{span:4}">
            <div class="step-item">
              <div class="top">
                <div class="conts">
                  <h5>展望未来</h5>
                  <p>站在新的历史节点，芦淞区姚家坝中医骨伤医院将继续坚守中医根脉，融合现代科技，打造“医、教、研、防”四位一体的区域性骨伤医疗中心</p>
                </div>
                <h6>至今</h6>
              </div>
            </div>
          </el-col>
        </div>
      </el-col>
    </div>

    <div class="bgbox-white">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:20,offset:2}">
        <div class="module7-conts">
          <div class="module-title">
            <span class="title-cn">医院地址</span>
            <span class="title-en">COMPANY ADDRESS</span>
          </div>
          <div class="map-box">
            <!-- 百度地图容器 -->
            <baidu-map
              class="bm-view"
              :center="center"
              :zoom="zoom"
              ak="2864FMW4Ct3sCOoin07oxvK8XFPaAPTm" 
              @ready="mapHandler"
            >
              <bm-marker :position="center" :dragging="false" animation="BMAP_ANIMATION_BOUNCE">
                <bm-label content="株洲市芦淞区姚家坝中医骨伤专科医院" />
              </bm-marker>
              <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
            </baidu-map>
          </div>
        </div>
      </el-col>
    </div>
    <el-dialog :visible.sync="showBigImg" :center="true" :show-close="false" custom-class="dialog-bigimg">
      <img :src="bigImgSrc" />
    </el-dialog>
  </div>
</template>

<script>
// 引入百度地图相关组件
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import BmMarker from 'vue-baidu-map/components/overlays/Marker'
import BmLabel from 'vue-baidu-map/components/overlays/Label'
import BmNavigation from 'vue-baidu-map/components/controls/Navigation'

export default {
  components: {
    BaiduMap,
    BmMarker,
    BmLabel,
    BmNavigation
  },
  data() {
    return {
      showBigImg: false,
      bigImgSrc: null,
      center: { lng: 113.3372840, lat: 27.7740579 }, // 医院经纬度
      zoom: 16 // 合适的缩放级别
    };
  },
  methods: {
    // 修复：只获取需要使用的map参数，移除未使用的BMap
    mapHandler({ map }) {
      // 地图加载完成后的回调
      console.log('百度地图加载完成', map);
    }
  }
};
</script>

<style lang="scss">
.join_us {
  display: block;
  width: 33%;
  max-width: 1920px;
  margin: 0 auto;
}

.BMap_cpyCtrl,
.anchorBL {
  display: none;
}

.BMapLabel {
  padding: 6px !important;
  border: 1px solid #0066cc !important;
  color: #0066cc !important;
  left: -45px !important;
  top: -30px !important;
  font-weight: bold !important;
}

// 大图弹窗样式
.dialog-bigimg {
  box-shadow: none;
  background: transparent;
  margin: 5% auto 0 !important;
  width: fit-content !important;
  height: auto !important;
  overflow: hidden;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
    width: fit-content !important;
    height: auto !important;

    img {
      max-width: 100%;
      max-height: 100%;
      margin: 0 auto;
      display: block;
    }
  }
}
</style>

<style lang="scss" scoped>
.bgbox-white {
  padding: 50px 10px;
  overflow: hidden;
  background: #fff;
  box-sizing: border-box;
}

.the-banner {
  height: 400px;
  background-image: url("../../assets/yyimages/sy-1.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.module-title {
  text-align: center;
  padding-bottom: 40px;

  .title-cn {
    display: block;
    font-size: 30px;
    font-weight: bold;
    color: #1f1f1f;
  }

  .title-en {
    display: block;
    font-size: 12px;
    font-weight: 400;
    color: #757575;
    line-height: 20px;
  }
}

.module1-conts {
  p {
    font-size: 14px;
    color: #1f1f1f;
    text-indent: 2em;
    line-height: 1.8;
  }
}

.module3-conts {
  overflow: hidden;

  .step-item {
    width: 100%;
    height: 520px;
    position: relative;

    &::before {
      content: '';
      height: 2px;
      width: 100%;
      background: #e6e6e6;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }

    .top {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      bottom: 221px;

      &::before {
        content: '';
        width: 10px;
        height: 10px;
        background: #0066cc;
        border-radius: 50%;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 35px;
      }

      &::after {
        content: '';
        width: 2px;
        height: 120px;
        border: 1px dashed #0066cc;
        box-sizing: border-box;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 35px;
      }

      .conts {
        background: #fff;
        padding: 0 10px;
        box-sizing: border-box;
        position: absolute;
        z-index: 9;
        padding-bottom: 10px;

        h5 {
          font-size: 16px;
          color: #0066cc;
          text-align: center;
          margin-bottom: 10px;
        }

        p {
          font-size: 14px;
          color: #1f1f1f;
        }
      }

      h6 {
        font-size: 16px;
        color: #1f1f1f;
        position: absolute;
        bottom: -30px;
        left: 50%;
        transform: translateX(-50%);
      }
    }

    .down {
      position: absolute;
      top: 221px;
      left: 0;
      width: 100%;
      bottom: 0;

      &::before {
        content: '';
        width: 10px;
        height: 10px;
        background: #0066cc;
        border-radius: 50%;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 35px;
      }

      &::after {
        content: '';
        width: 2px;
        height: 120px;
        border: 1px dashed #0066cc;
        box-sizing: border-box;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 35px;
      }

      .conts {
        background: #fff;
        padding: 0 10px;
        box-sizing: border-box;
        position: absolute;
        bottom: 0;
        z-index: 9;
        padding-top: 10px;

        h5 {
          font-size: 16px;
          color: #0066cc;
          text-align: center;
          margin-bottom: 10px;
        }

        p {
          font-size: 14px;
          color: #1f1f1f;
        }
      }

      h6 {
        font-size: 16px;
        color: #1f1f1f;
        position: absolute;
        top: -30px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}

.module7-conts {
  .map-box {
    height: 500px;
    overflow: hidden;
  }

  .bm-view {
    width: 100%;
    height: 100%;
  }
}

// 移动端适配
@media screen and (max-width: 767px) {
  .the-banner {
    height: 260px;
  }

  .module-title .title-cn {
    font-size: 24px;
  }

  .module3-conts .step-item {
    height: auto;
    margin-bottom: 60px;

    &::before {
      display: none;
    }

    .top,
    .down {
      &::before,
      &::after {
        display: none;
      }

      .conts {
        position: relative;
        margin-bottom: 10px;
      }

      h6 {
        position: relative;
        bottom: auto;
        top: auto;
        display: inline-block;
      }
    }
  }

  .module7-conts .map-box {
    height: 300px;
  }
}
</style>